import React, { useState, useEffect } from 'react';
import { PrimaryButton, Button, TextButton } from 'components/buttons';

export default function SettingsItem({ 
  label, 
  value, 
  displayValue, 
  onUpdate, 
  loading, 
  children 
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  const handleSave = () => {
    onUpdate(currentValue);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setCurrentValue(value);
    setIsEditing(false);
  };

  return (
    <div className="py-6 sm:flex">
      <dt className="font-medium text-white sm:w-64 sm:flex-none sm:pr-6">{label}</dt>
      <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
        {isEditing ? (
          <div className="w-full max-w-md">
            {typeof children === 'function' 
              ? children({ value: currentValue, onChange: setCurrentValue }) 
              : children}
            <div className="mt-4 flex gap-3">
              <PrimaryButton
                onClick={handleSave}
                disabled={loading}
              >
                Save
              </PrimaryButton>
              <Button
                onClick={handleCancel}
                disabled={loading}
              >
                Cancel
              </Button>
            </div>
          </div>
        ) : (
          <>
            <div className="text-gray-400">{displayValue || value || 'Not set'}</div>
            <TextButton
              onClick={() => setIsEditing(true)}
            >
              Update
            </TextButton>
          </>
        )}
      </dd>
    </div>
  );
}
